/**CORE LIBRARIES IMPORT */
import React from "react";
import { Link } from "react-router-dom";

/**HOOKS IMPORT */
import usePageTitle from "../hooks/usePageTitle";

const NotFound = () => {
  usePageTitle("Page not found");

  return (
    <main className="simple-page">
      <p className="page-eyebrow">404</p>
      <h1 className="page-title">Page not found</h1>
      <p className="section-text">The page you're looking for doesn't exist or has moved.</p>
      <div className="event-actions">
        <Link to="/" className="hero-btn">Back to Home</Link>
        <Link to="/menu" className="hero-btn">View Menu</Link>
      </div>
    </main>
  );
};

export default NotFound;
